import React, { useEffect, useRef, useState } from "react";
import { SectionCard } from "./common";
import { SchemaForm } from "./forms";
import { OutlineButton } from "@/components/Primitives";
import { api } from "@/lib/api";
import { UploadCloud, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";

const SCHEMA = [
  { key: "insurer", label: "Insurer" },
  { key: "policy_number", label: "Policy Number" },
  { key: "policy_type", label: "Policy Type", type: "select", options: ["Building", "Landlord", "Contents", "Building & Contents", "Strata"] },
  { key: "premium", label: "Premium", type: "number" },
  { key: "renewal_date", label: "Renewal Date", type: "date" },
  { key: "excess", label: "Excess", type: "number" },
  { key: "coverage", label: "Coverage" },
  { key: "broker", label: "Broker" },
  { key: "notes", label: "Notes" },
];

export function InsuranceTab({ property, reload }) {
  const [policyDocId, setPolicyDocId] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef();

  const loadPolicy = () => api.get(`/properties/${property.id}/documents`).then((r) => {
    const ins = r.data.filter((d) => d.property_category === "Insurance");
    setPolicyDocId(ins[0]?.id || null);
  }).catch(() => {});
  useEffect(() => { loadPolicy(); /* eslint-disable-next-line */ }, [property.id]);

  const save = async (payload) => {
    await api.put(`/properties/${property.id}/insurance`, { ...payload, reminder_dates: property.insurance?.reminder_dates || [] });
    reload();
  };

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    const fd = new FormData(); fd.append("file", f); fd.append("category", "Insurance");
    try { await api.post(`/properties/${property.id}/documents/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Policy uploaded"); loadPolicy(); }
    catch { toast.error("Could not upload"); } finally { setBusy(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  return (
    <SectionCard title="Insurance policy" action={
      <div className="flex flex-wrap gap-2">
        <input ref={fileRef} type="file" className="hidden" onChange={onFile} data-testid="insurance-file-input" />
        <OutlineButton data-testid="insurance-upload" disabled={busy} onClick={() => fileRef.current?.click()}>
          {busy ? <Loader2 size={14} className="animate-spin" /> : <UploadCloud size={14} />} Upload Policy
        </OutlineButton>
        {policyDocId && (
          <a data-testid="insurance-view" href={`${process.env.REACT_APP_BACKEND_URL}/api/documents/${policyDocId}/file`} target="_blank" rel="noreferrer">
            <OutlineButton><FileText size={14} /> View Policy</OutlineButton>
          </a>
        )}
      </div>
    }>
      <SchemaForm schema={SCHEMA} initial={property.insurance || {}} onSave={save} testidPrefix="insurance" />
    </SectionCard>
  );
}
